export const defaultTermsEffectiveAt = '2026-07-18T00:00:00.000Z'

export function termsNeedAcceptance(profile, terms) {
    return Boolean(terms && (
        profile?.termsAcceptedEffectiveAt !== terms.effectiveAt ||
        (profile?.termsAcceptedOrgId || null) !== (terms.orgId || null)
    ))
}

export function sameTerms(a, b) {
    return Boolean(a && b && a.effectiveAt === b.effectiveAt &&
        (a.orgId || null) === (b.orgId || null))
}
